import { InvoiceSubmitForm } from './InvoiceSubmitForm';
import type { InvoiceDetailsForm } from '../hooks/useInvoiceDetailsForm';

export interface InvoiceDetailsSectionProps {
    submitReasons: string[];
    form: InvoiceDetailsForm;
    disabledReason: string | null;
    submitVariant?: 'primary' | 'outline';
}

/** Rendered inside `PermissionGuard{invoice.add}`. */
export function InvoiceDetailsSection({
    submitReasons,
    form,
    disabledReason,
    submitVariant = 'primary',
}: InvoiceDetailsSectionProps) {
    return (
        <section aria-labelledby="invoice-details-heading" className="space-y-4">
            <h3 id="invoice-details-heading" className="text-sm font-semibold text-mp-foreground">
                Details
            </h3>

            <InvoiceSubmitForm
                form={form}
                reasons={submitReasons}
                disabled={disabledReason !== null}
                disabledReason={disabledReason}
                submitVariant={submitVariant}
            />
        </section>
    );
}
